import "../src/assets/style.scss"
import "../src/assets/js/menu"
import "../src/assets/js/showmore"

// // BOOTSTRAP ICONS 
// import "bootstrap-icons/font/bootstrap-icons.css";

// // import Swiper styles
// import 'swiper/css';  
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
